import { IClientWebEmbeddingSharedState } from './sharedState';

export enum ClientWebEmbeddingMessageType {
  /**
   * Message with "ready" type should be sent when member is ready
   * to receive and handle messages from another member
   */
  Ready = 'ready',

  ClientIsLoggedIn = 'clientIsLoggedIn',
  ClientIsLoggedOut = 'clientIsLoggedOut',
  ComeToForeground = 'comeToForeground',

  IntroCatalogTypeChanged = 'introCatalogTypeChanged',
  IntroCareerIdChanged = 'introCareerIdChanged',

  RequestPushNotificationsSubscribing = 'requestPushNotificationsSubscribing',

  SharedStateUpdated = 'sharedStateUpdated',
}

export type ClientWebEmbeddingMessage =
  | {
      type: ClientWebEmbeddingMessageType.Ready;
    }
  | {
      type: ClientWebEmbeddingMessageType.ClientIsLoggedIn;
      token: string;
    }
  | {
      type: ClientWebEmbeddingMessageType.ClientIsLoggedOut;
    }
  | {
      type: ClientWebEmbeddingMessageType.ComeToForeground;
    }
  | {
      type: ClientWebEmbeddingMessageType.IntroCatalogTypeChanged;
      catalogType: number;
    }
  | {
      type: ClientWebEmbeddingMessageType.IntroCareerIdChanged;
      careerId: number;
    }
  | {
      type: ClientWebEmbeddingMessageType.RequestPushNotificationsSubscribing;
    }
  | {
      type: ClientWebEmbeddingMessageType.SharedStateUpdated;
      stateUpdate: Partial<IClientWebEmbeddingSharedState>;
    };
